import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SubscriptionCurrencyPipe } from '@app/pipes/subscription-currency.pipe';

export interface OrderSummaryRowItemModel {
  description: string | SafeHtml;
  amount: number;
  note?: string | SafeHtml;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'order-summary-row',
  imports: [CommonModule, SubscriptionCurrencyPipe],
  templateUrl: './order-summary-row.component.html',
})
export class OrderSummaryRowComponent {
  @Input()
  item: OrderSummaryRowItemModel;

  @Input()
  extraItem?: OrderSummaryRowItemModel;

  @Input()
  isDiscount: boolean;
}
